import type { MqttTopicDto } from "~/types/api";

export const MqttVersionEnum = {
  "3.1.1": 0,
  "3.1.0": 1,
};

export const MqttSSLModeEnum = {
  NONE: 0,
  CA_SIGNED: 1,
  SELF_SIGNED: 2,
};

export const deafaultMqttTopic = {
  parsingType: 0,
  decoder: `function Decode(topic, payload) {
  var json = JSON.parse(payload);

  return [
    {
      deveui: "deveui-to-add-value-to", 
      key: "temp", 
      value: json.temprature, 
      timestamp: new Date()
    }
  ];
}`,
} as MqttTopicDto;

export const MqttTopicDecoderEnum = {
  DEFAULT: 0,
  JSON: 1,
  HEX: 2,
  BASE64: 3,
};

export const mqttTopicDecoders = Object.values(MqttTopicDecoderEnum);
